import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import subscriptionStatus from "../components/SubscriptionStatus.js";
import config from "../config";

const baseUrl = config.baseURL;
const Logout = () => {
  const isSubscribed = subscriptionStatus();
  const navigate = useNavigate();

  const handleLogoutClick = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${baseUrl}/api/logout`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-page-url": "/logout",
        },
      });

      const data = await response.json();
      console.log("Logout response:", data);
    } catch (err) {
      console.error("Logout API error:", err);
    } finally {
      // Always remove token and redirect even if API fails
      localStorage.removeItem("token");
      navigate("/");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#F5F5F5",
        fontFamily: "Roboto, sans-serif",
        padding: "30px",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "450px",
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: "600", marginBottom: "24px", color: "#34495E" }}
        >
          We will miss you,
        </Typography>

        <Button
          variant="contained"
          onClick={handleLogoutClick}
          sx={{
            backgroundColor: "#34495E",
            color: "white",
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "bold",
            borderRadius: "8px",
            textTransform: "none",
            width: "100%",
            "&:hover": {
              backgroundColor: "#5D6D7E",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
            },
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );
};

export default Logout;
